import { render, staticRenderFns } from "./LinkWindow.vue?vue&type=template&id=4b921623"
import script from "./LinkWindow.vue?vue&type=script&lang=js"
export * from "./LinkWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports